<template>
  <v-container fluid tag="section">
    <div v-if="!isAffiliated && (!ifEnte || enteData.code !='LIBERTAS')" class="mx-auto" max-width="400">
      <v-img class="white--text align-end" height="200px" src="/API/public/portal/getImage/THEME/login">
      </v-img>
      <v-card-title>{{ $t("affiliation_is_required") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-card-subtitle class="pb-0">
        </v-card-subtitle>
      </v-card-text>
    </div>
    <div v-else-if="mode === 'MyASD'">
      <v-stepper v-model="stepper" v-if="!waitingAffiliationApprove">
        <v-stepper-header>
          <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{ $t("select_users")
            }}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{ $t("exec_payment")
            }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-row>
              <v-col cols="12">
                <DataTables @showUser="showUser" :headers="headers" :selected="selected" :showSelect="true"
                  itemKey="key" v-model="selected" :tableData="tableData"></DataTables>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="gotoStep2" color="success">{{
                  $t("confirm_choise")
                  }}</v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="2">
            <v-row>
              <v-col cols="12">
                <select-mod-pag :riepilogo="riepilogo" @selected="confirmOrder"></select-mod-pag>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <div v-else class="mx-auto" max-width="400">
        <v-img class="white--text align-end" height="200px" src="/API/public/portal/getImage/THEME/login">
        </v-img>
        <v-card-title>{{ $t("data_waiting_for_approvation") }}</v-card-title>

        <v-card-text class="text--primary">
          <v-card-subtitle class="pb-0">
            {{ asdAffiliazione }}
          </v-card-subtitle>
        </v-card-text>
      </div>

      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">
              {{ $t("confirm_order") }}
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>{{ $t("beneficiary") }}</td>
                    <td>{{ enteData.ragSoc }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("type") }}</td>
                    <td>
                      {{
                        isAffiliated
                          ? $t("affiliation_cards")
                          : $t("ente_affiliation")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("total") }}</td>
                    <td>{{ riepilogo.totale }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("payment_date") }}</td>
                    <td>
                      {{
                        params.dataPag
                          ? new Date(params.dataPag).toLocaleDateString("it")
                          : new Date().toLocaleDateString("it")
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog = false">
                {{ $t("undo") }}
              </v-btn>
              <v-btn color="green darken-1" text @click="sendOrder">
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <profile-page @isUpdated="loadTable" ref="userProfileDialog"></profile-page>
    </div>    
    
    <div v-else-if="mode === 'LIBERTAS'">
    <div v-if="!waitingAffiliationApprove">
            <v-row>
              <v-col cols="12">
                <DataTables @showUser="showUser" :headers="headers" :selected="selected" :showSelect="true"
                  itemKey="key" v-model="selected" :tableData="tableData"></DataTables>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="confirmLIBERTAS" color="success">{{
                  $t("confirm_choise")
                  }}</v-btn>
              </v-col>
            </v-row>
          </div>
      <div v-else class="mx-auto" max-width="400">
        <v-img class="white--text align-end" height="200px" src="/API/public/portal/getImage/THEME/login">
        </v-img>
        <v-card-title>{{ $t("data_waiting_for_approvation") }}</v-card-title>

        <v-card-text class="text--primary">
          <v-card-subtitle class="pb-0">
            {{ asdAffiliazione }}
          </v-card-subtitle>
        </v-card-text>
      </div>

      <profile-page @isUpdated="loadTable" ref="userProfileDialog"></profile-page>
    </div>
    
    <div v-else-if="mode === 'ASI' || mode === 'ENDAS' || mode === 'PGS'">
      <v-container>
        <v-row justify="center">
          <v-col class="text-center">
            <v-btn @click="generateFile()" color="primary">{{
              $t("generate_csv_affiliation")
              }}</v-btn>
          </v-col>
          <v-col class="text-center">
            <v-file-input v-model="files" @change="uploadFile" color="primary" :label="$t('upload_csv_affiliation')"
              prepend-icon="mdi-paperclip" outlined accept="text/csv" :display-size="1000" />
          </v-col>
        </v-row>
        <v-row v-if="listError">
          <v-col cols="12">
            <h4>Error</h4>
            <v-simple-table>
              <tbody>
                <tr v-for="error in listError" v-bind:key="error">
                  <td>{{ error }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row v-if="listUpdated">
          <v-col cols="12">
            <h4>Updated</h4>
            <v-simple-table>
              <tbody>
                <tr v-for="updated in listUpdated" v-bind:key="updated">
                  <td>{{ updated }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-else-if="mode === 'OPES'">
      <v-container>
        <v-row justify="center">
          <v-col md="2" cols="12" class="text-center">
            <my-datepicker v-model="dateInz" :label="$t('date_inz')" required="true" /> </v-col><v-col md="2" cols="12"
            class="text-center">
            <my-datepicker v-model="dateEnd" :label="$t('date_end')" required="true" />
          </v-col>
          <v-col md="2" cols="12" class="text-center">
            <v-btn @click="generateFile()" color="primary">{{
              $t("generate_zip_affiliation")
              }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import selectModPag from "@/widget/selectModPag.vue";

import Swal from "sweetalert2";
import moment from "moment";

let _ = this;
export default {
  name: "user-2-affiliate",
  components: {
    DataTables,
    profilePage,
    MyDatepicker,
    selectModPag,
  },
  data() {
    return {
      files: [],
      listUpdated: null,
      listError: null,
      dateInz: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateEnd: new Date(),
      dialog: false,
      isAffiliated: false,
      waitingAffiliationApprove: false,
      affilationList: [],
      asdAffiliazione: null,
      mode: "MyASD",
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("qta"), value: "qta" },
          { text: this.$t("price"), value: "prezzo" },
          { text: this.$t("total"), value: "total" },
        ],
        items: [],
        totale: 0,
      },
      stepper: 1,
      params: {
        pagId: null,
        asdAffiliazione: null,
        dettaglio: [],
      },
      selected: [],  
      headers: [ 
        { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("qualify"), value: "qualifica", type: "text" },
        { text: this.$t("date_affiliation"), value: "dateTes", type: "date" },
        { text: this.$t("price"), value: "prezzo", type: "number" },
        { text: this.$t("type_affiliation_card_ente"), value: "graphTessera", type: "imageHtml" },
        { text: this.$t("number_affiliation_card_ente"), value: "tesseraEnte", type: "text" },
        { text: this.$t("status"), value: "status", type: "icons" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    confirmLIBERTAS: async function (data) {
      let _ = this;
      let success = true;
      let title = "";
      let message = ""
      let response = null;
      let newTableData = JSON.parse(JSON.stringify(_.tableData));
      for (let keyId of  _.selected){
        let index = newTableData.findIndex(el => el.key === keyId);
        response = await _.chiamataAxios(
          "POST", "/auth/tesseramenti/tesseramentoLIBERTAS/"+keyId,
          { dialogLoader: true, returnDataOnError: true, silentError: true }
       );
       message = response.msg.msgTxt;
        if(!response.msg.esito)  {
          success = false;
          title = response.msg.title;
          message = response.msg.msgTxt;
          response.data.tesseraEnte = response.msg.msgTxt;
        }
        newTableData[index] =_.mapResponse(response.data)        
    }
    _.tableData =newTableData;
    Swal.fire({
          type: success ? "success" : "error",
          title: success
            ? _.$t("operation_successfully_completed")
            : _.$t("there_was_an_error"),
          html: message
        });
    },
    sendOrder: function (data) {
      let _ = this;
      _.dialog = false; 
      _.chiamataAxios(
        "POST",
        _.isAffiliated
          ? "/auth/ente/buyEnteTessere/"
          : "/auth/ente/buyAffiliazione/",
        { dialogLoader: true, body: _.params }
      ).then((response) => {
        Swal.fire({
          type: response.msg.esito ? "success" : "error",
          title: response.msg.esito
            ? _.$t("operation_successfully_completed")
            : _.$t("there_was_an_error"),
          html: response.msg.msgTxt,
        });

        if (response.msg.esito) _.$router.push("/portal/");
      });
    },
    confirmOrder: function (data) {
      this.params.pagId = data.pagId;
      this.params.dataPag = data.dataPag;
      this.params.dexPag = data.title;
      this.dialog = true;
    },
    gotoStep2: function () {
      let _ = this;
      _.riepilogo.totale = 0;
      _.riepilogo.items = [];
      _.params = {
        pagId: null,
        asdAffiliazione: null,
        dettaglio: [],
      };
      // Prepara ordine e riepilogo
      if (_.isAffiliated) {
        let aggregato = [];
        for (let utente of _.tableData) {
          if (_.selected.includes(utente.key)) {
            if (!aggregato[utente.asdTesId + "_" + utente.prezzo]) {
              aggregato[utente.asdTesId + "_" + utente.prezzo] = {
                tesId: utente.asdTesId,
                item: utente.asdTesTipo,
                image: utente.tesseraImage,
                prezzo: utente.prezzo,
                qta: 0,
              };
            }
            _.params.dettaglio.push(utente.key);
            aggregato[utente.asdTesId + "_" + utente.prezzo].qta += 1;
          }
        }
        for (let tesId in aggregato) {
          _.riepilogo.totale += aggregato[tesId].prezzo * aggregato[tesId].qta;
          _.riepilogo.items.push({
            item: aggregato[tesId].item,
            qta: aggregato[tesId].qta,
            prezzo: aggregato[tesId].prezzo,
            total: aggregato[tesId].prezzo * aggregato[tesId].qta,
          });
        }
        if (_.selected.length > 0) _.stepper = 2;
      }
    },
    showUser(item) {
      this.$refs.userProfileDialog.open(item.masterId, 4);
    },
    generateFile: function () {
      let params = {};
      if (this.mode === "OPES")
        params = { dateInz: this.dateInz, dateEnd: this.dateEnd };
      let link = this.authorizeLink(
        "/auth/tesseramenti/getEnteTesseramentiFile/" +
        btoa(JSON.stringify(params))
      );
      window.open(link);
    },
    uploadFile: function () {
      let _ = this;
      _.listUpdated = null;
      _.listError = null;
      let url = "/auth/tesseramenti/updateEnteTesseramentiFromFile";
      //console.dir([_.files[0]])
      let file = _.files;
      if (!file) return;
      let reader = new FileReader();
      reader.onload = (e) => {
        let base64 = e.target.result;
        _.chiamataAxios("POST", url, {
          dialogLoader: true,
          body: {
            file: base64,
          },
        }).then((response) => {
          if (response.msg.esito) {
            _.listUpdated = response.data.updated;
            _.listError = response.data.error;
          }
        });
        _.files = null;
      };
      reader.readAsDataURL(file);
    },
    mapResponse(item){
      let _ = this;

      //if(!item.tesseraEnte) item.tesseraEnte = "a"
      
      item.graphTessera ={image: item.tesseraImage, html: 
        '<h4 style="color: ' +
        item.asdTesHexColor +
        ';">' +
        item.asdTesTipo +
        "</h4>"};

      item.options = [
        {
          icon: "mdi-magnify",
          color: "primary",
          function: "showUser",
        },
      ];
      if (item.esito && item.esito.status === false) {
        item.status = [
          {
            icon: "mdi-close",
            color: "red",
            text: item.esito.text,
          },
        ];
      } else if ((item.esito && item.esito.status === true) || (item.tesseraEnte && item.tesseraEnte != "")) {
        _.selected = _.selected.filter(el => {return el !== item.key})
        item.disabled = true;
        item.status = [
          {
            icon: "mdi-check",
            color: "success",
            text: item.esito.text,
          },
        ];
      }
      else if (item.waitingApproval) {
        _.selected = _.selected.filter(el => {return el !== item.key})
        item.disabled = true;
        item.status = [
          {
            icon: "mdi-clock-time-three-outline",
            color: "warning",
            text: _.$t("data_waiting_for_approvation"),
          },
        ];
      } else item.status = null;

      return item;
    },
    loadTable() {
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      _.isAffiliated = false;
      _.chiamataAxios("GET", "/auth/ente/getListinoTessere").then(
        (response) => { 
          _.mode = response.data.mode;
          _.isAffiliated = response.data.affiliated;
          _.waitingAffiliationApprove = response.data.waitingAffiliationApprove;
          _.affilationList = response.data.affilationList;
          _.asdAffiliazione = response.data.asdAffiliazione;
          if (_.isAffiliated || (_.ifEnte && _.enteData.code =="LIBERTAS"))
            _.chiamataAxios(
              "GET",
              "/auth/tesseramenti/listUser2affiliate"
            ).then((response) => {
              _.tableData = response.data.map(function (item) {  return _.mapResponse(item) });

              _.isFetching = false;
            });
        }
      );
    },
  },
  created() {
    this.loadTable();
  },
  computed: {
    enteData: function () {
      return window.systemData.ente;
    },
    ifEnte: function () {
      return window.systemData.ifEnte;
    },
  },
};
</script>
